type Props = {
    lines: string[];
};

export function ProfileDetailsValue({ lines }: Props) {
    const shownLines = lines.filter((line) => line.trim() !== '');

    return (
        <div className="text-base font-bold text-foreground">
            {shownLines.length > 0 ? (
                shownLines.map((line, index) => (
                    // Lines sit in fixed positions and their text can repeat, so the text is no key.
                    // biome-ignore lint/suspicious/noArrayIndexKey: see above
                    <p key={index}>{line}</p>
                ))
            ) : (
                <p>--</p>
            )}
        </div>
    );
}
